
import { clientModule } from '@/modules/client/client.vuex-module';
import { orderModule } from '@/modules/order/orderModule.vuex-module';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import moment from 'moment';

@Options({
	name: 'TimeWarnView',
	components: {},
})
export default class TimeWarnView extends Vue {
	@Prop({ default: '0' }) next!: string;
	get type(): string {
		switch (this.next) {
			case 'OrderTimeEdit':
				return 'Reschedule Policy';
			case 'OrderTimeCancel':
				return 'Cancellation Policy';
			case 'OrderTimeSwap':
				return 'Swap Policy';
			default:
				return 'Cancellation Policy';
		}
	}
	get canEdit(): boolean {
		switch (this.next) {
			case 'OrderTimeEdit':
				return !!orderModule.openActivity?.activity.AllowSelfReschedule;
			case 'OrderTimeCancel':
				return !!orderModule.openActivity?.activity.AllowSelfCancellation;
			case 'OrderTimeSwap':
				return !!orderModule.openActivity?.activity.ShowSwapActivityButton;
			default:
				return false;
		}
	}
	get changeWindow() {
		const windows = orderModule.openActivity?.activity.EntityHierarchyChangeWindows ?? [];
		const typeKey = this.next === 'OrderTimeEdit' ? 1 : this.next === 'OrderTimeSwap' ? 3 : 2;
		return windows.find((w) => w.ChangeWindowTypeKey === typeKey) ?? null;
	}
	get feeAmount(): number {
		// A swap never carries a fee; the new activity's price difference applies instead.
		if (this.next === 'OrderTimeSwap') return 0;
		return this.changeWindow?.Fee ?? 0;
	}
	get feeTypeLabel(): string {
		return this.changeWindow?.ChangeFeeTypeKey === 2 ? 'per order' : 'per guest';
	}
	get copy(): string {
		switch (this.next) {
			case 'OrderTimeEdit':
				return orderModule.openActivity?.activity.ReschedulePolicy ?? '';
			case 'OrderTimeCancel':
				return orderModule.openActivity?.activity.CancellationPolicy ?? '';
			case 'OrderTimeSwap':
				return this.swapPolicy;
			default:
				return `This activity is part of a package and is unable to be cancelled online. Please call our staff at ${clientModule.location?.PublicPhoneNumber} for assistance!`;
		}
	}
	get swapPolicy(): string {
		const pricing = "The booking moves to the new activity's price. You'll pay any increase, and any decrease can be refunded or kept as a credit on your order. No change fee is charged.";
		const appointment = orderModule.openActivity?.selectedTimes[0]?.Appointment?.Time;
		const hours = this.changeWindow?.ToHours ?? 0;
		if (!appointment || hours <= 0) return pricing;
		const until = moment(appointment).subtract(hours, 'hours');
		return `This booking can be swapped until ${until.format('h:mm A')} on ${until.format('ddd, MMM DD, YYYY')}. ${pricing}`;
	}
	onNext() {
		if (this.canEdit) {
			this.$router.push({ name: this.next });
		} else {
			this.$router.go(-1);
		}
	}
}
